export default {
  stats_years_value: '15+',
  stats_satisfaction_value: '100%',
  whyus_bar_customer_value: '100',
  whyus_bar_timely_value: '98',
  whyus_bar_reliable_value: '99',
  whyus_bar_quality_value: '97',
};